import { _Base } from "./_Base";
import { endpoints } from "./endpoints";

export class Configuration extends _Base {
  endPointRoot = process.env.REACT_APP_ROOT_T_REST;

  public async getStructures() {
    const url = this.endPointRoot + endpoints.structures.get;

    const response = await this.prepareGet(url, null);

    // Fake response waiting the server implementation
    response.data["permissions"] = [
      {
        id: "MASTER",
        name: "Administrator",
        title: "Administrator",
        editable: false,
        display: false,
      },
      {
        id: "DATA_API",
        name: "Data API",
        title: "Data API",
        editable: true,
        display: true,
      },
      {
        id: "SELLER",
        name: "Seller",
        title: "Seller",
        editable: false,
        display: true,
      },
      {
        id: "DIRECTORY",
        name: "Directory",
        title: "Strategy builder Directory Button",
        editable: true,
        display: true,
        product: ["RISE", "ADVANCED", "SYSTEMATIC_ENGINE"],
      },
      {
        id: "AI_STRATEGY_ADVISOR",
        name: "Ai strategy advisor",
        title: "Ai strategy advisor",
        editable: true,
        display: true,
      },
      {
        id: "ORCHESTRATOR",
        name: "Orchestration",
        title: "Orchestration",
        editable: false,
        display: false,
      },
    ];

    return response.data;
  }
}
